module.exports = __webpack_public_path__ + "static/media/comprar-imovel-joinville-mobile.9369d434.png";